(function () {
  var STORAGE_KEY = 'pm_wa_closed';
  var TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

  function init() {
    var root = document.querySelector('[data-pm-wa]');
    if (!root) return;

    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        var ts = parseInt(stored, 10);
        if (!isNaN(ts) && Date.now() - ts < TTL_MS) {
          root.classList.add('is-hidden');
        } else {
          localStorage.removeItem(STORAGE_KEY);
        }
      }
    } catch (e) {
      // localStorage unavailable -- show button anyway
    }

    var closeBtn = root.querySelector('[data-pm-wa-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        root.classList.add('is-hidden');
        try {
          localStorage.setItem(STORAGE_KEY, String(Date.now()));
        } catch (e) {
          // ignore
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
